<template>
  <v-container v-if="DataCuestionario !== null" grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card :elevation="2" :loading="loading" :disabled="loading">
          <v-card-title>Administración de cuestionarios</v-card-title>
          <v-card-text active-class="deep-purple accent-4 white--text">
            <v-flex xs12 sm12>
              <v-data-table
                :headers="headerCuestionario"
                :items="gcuestionarios"
                class="elevation-1"
                :no-data-text="gnodata"
                :items-per-page="5"
              >
                <template v-slot:[`item.activo`]="{ item }">
                  <v-simple-checkbox v-model="item.activo" disabled></v-simple-checkbox>
                </template>
                <template v-slot:top>
                  <v-toolbar>
                    <v-toolbar-title>Lista de cuestionarios</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          x-large
                          v-on="on"
                          @click="newcuestionario"
                          v-scroll-to="'#containera'"
                        >
                          <v-icon color="primary">add</v-icon>
                        </v-btn>
                      </template>
                      <span>Agregar</span>
                    </v-tooltip>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        v-scroll-to="'#containera'"
                        @click="grideditCuestionario(item, 'editar')"
                      >edit</v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        v-scroll-to="'#containera'"
                        @click="grideditCuestionario(item, 'preguntas')"
                      >help</v-icon>
                    </template>
                    <span>Preguntas</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        small
                        v-on="on"
                        v-show="showpregunta(item)"
                        @click="deleteCuestionario(item)"
                      >delete</v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
              </v-data-table>

              <v-divider></v-divider>
            </v-flex>
            <v-card id="containera" ref="containera" v-show="framesubform" color="#EEEEEE">
              <v-card-title>{{EditedCuestionario.codigo}}</v-card-title>
              <v-card-text>
                <v-system-bar dark>
                  <v-spacer></v-spacer>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" @click="cerrarsubform">mdi-close</v-icon>
                    </template>
                    <span>Cerar</span>
                  </v-tooltip>
                </v-system-bar>

                <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left" v-model="statetabs" background-color="blue-grey lighten-4" horizontal>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab :disabled="TabCuestionario">
                    <v-icon left>note_add</v-icon>Datos del cuestionario
                  </v-tab>
                  <v-tab :disabled="TabPeguntas">
                    <v-icon left>description</v-icon>Preguntas
                  </v-tab>
                  <v-tab-item>
                    <v-form data-vv-scope="form-cuestionario">
                      <v-card>
                        <v-card-text>
                          <v-flex row wrap>
                            <v-flex sm5 xs12>
                              <v-autocomplete
                                :items="gindicadores"
                                v-model="EditedCuestionario.idindicador"
                                item-text="codigo"
                                item-value="idindicador"
                                label="Indicadores étnicos *"
                                v-validate="'required'"
                                data-vv-name="indicadores_etnicos"
                                :error-messages="errors.collect('indicadores_etnicos')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex sm3 xs12>
                              <v-text-field
                                v-model="EditedCuestionario.cantidad"
                                label="Cantidad: *"
                                v-validate="'required'"
                                data-vv-name="cantidad"
                                :error-messages="errors.collect('cantidad')"
                              ></v-text-field>
                            </v-flex>
                            <v-flex sm2 xs12>
                              <v-text-field
                                v-model="EditedCuestionario.orden"
                                label="Orden: *"
                                v-validate="'required'"
                                data-vv-name="orden"
                                :error-messages="errors.collect('orden')"
                              ></v-text-field>
                            </v-flex>
                            <v-flex sm2 xs12>
                              <v-checkbox v-model="EditedCuestionario.activo" label="Activo"></v-checkbox>
                            </v-flex>
                          </v-flex>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="mx-1"
                                color="blue darken-1"
                                v-on="on"
                                @click="validarformCuestionario"
                              >Guardar</v-btn>
                            </template>
                            <span>Guardar</span>
                          </v-tooltip>
                        </v-card-actions>
                      </v-card>
                    </v-form>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-flex xs12 sm12>
                          <v-data-table
                            :headers="headerPreguntas"
                            :items="DataPreguntas"
                            class="elevation-1"
                            :no-data-text="gnodata"
                            :items-per-page="5"
                          >
                            <template v-slot:top>
                              <v-toolbar>
                                <v-toolbar-title>Lista de preguntas</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      x-large
                                      v-on="on"
                                      @click="newPregunta"
                                      v-scroll-to="'#containera'"
                                    >
                                      <v-icon color="primary">add</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Agregar</span>
                                </v-tooltip>
                              </v-toolbar>
                            </template>
                            <template v-slot:item.action="{ item }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    v-on="on"
                                    small
                                    class="mr-2"
                                    v-scroll-to="'#containera'"
                                    @click="grideditPregunta(item)"
                                  >edit</v-icon>
                                </template>
                                <span>Editar</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon small v-on="on" @click="deletePreguntas(item)">delete</v-icon>
                                </template>
                                <span>Eliminar</span>
                              </v-tooltip>
                            </template>
                          </v-data-table>

                          <v-divider></v-divider>
                        </v-flex>
                        <v-form data-vv-scope="form-preguntas">
                          <v-card v-show="framepreguntas">
                            <v-card-text>
                              <v-flex row wrap>
                                <v-flex sm5 xs12>
                                  <v-select
                                    :items="gtipopreguntas"
                                    v-model="EditedPreguntas.idtipopregunta"
                                    item-text="nombre"
                                    item-value="idtipopregunta"
                                    label="Tipo de Pregunta *"
                                    v-validate="'required'"
                                    data-vv-name="tipopregunta"
                                    :error-messages="errors.collect('tipopregunta')"
                                  ></v-select>
                                </v-flex>
                                <v-flex sm3 xs12>
                                  <v-text-field
                                    v-model="EditedPreguntas.nombre"
                                    label="Pregunta: *"
                                    v-validate="'required'"
                                    data-vv-name="pregunta"
                                    :error-messages="errors.collect('pregunta')"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex sm2 xs12>
                                  <v-text-field
                                    v-model="EditedPreguntas.orden"
                                    label="Orden: *"
                                    v-validate="'required'"
                                    data-vv-name="ordenpregunta"
                                    :error-messages="errors.collect('ordenpregunta')"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex sm2 xs12>
                                  <v-checkbox v-model="EditedPreguntas.activo" label="Activo"></v-checkbox>
                                </v-flex>
                              </v-flex>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    class="mx-1"
                                    color="blue darken-1"
                                    v-on="on"
                                    @click="validarformpreguntas"
                                  >Guardar</v-btn>
                                </template>
                                <span>Guardar</span>
                              </v-tooltip>
                            </v-card-actions>
                          </v-card>
                        </v-form>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snack" :timeout="5000" :color="MesaggeInfo.color">
      {{this.MesaggeInfo.codigoRespuesta}}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="snack = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
export default {
  name: "admincuestionario",
  data() {
    return {
      loading: false,
      headerCuestionario: [
        { text: "Indicador", value: "codigoindicador", align: "left" },
        { text: "Cantidad", value: "cantidad", align: "left" },
        { text: "Orden", value: "orden", align: "left" },
        { text: "Activo", value: "activo", align: "center" },
        { text: "id", value: "idcuestionario", align: " d-none" },
        { text: "Acciones", value: "action", sortable: false },
      ],
      headerPreguntas: [
        { text: "Id", value: "idpregunta", align: " d-none" },
        { text: "Pregunta", value: "nombre", align: "left" },
        { text: "Tipo Pregunta", value: "nombretipopregunta", align: "left" },
        { text: "Orden", value: "orden", align: "left" },
        { text: "IdTP", value: "idtipopregunta", align: " d-none" },
        { text: "Activo", value: "activo", align: "center" },
        { text: "Acciones", value: "action", sortable: false },
      ],
      DataCuestionario: [],
      DataPreguntas: [],
      EditedCuestionario: [],
      EditedPreguntas: [],
      framesubform: false,
      TabPeguntas: false,
      TabCuestionario: false,
      frameeditar: false,
      framepreguntas: false,

      statetabs: 0,
      // table
      editedCuestionarioIndex: -1,
      editedPreguntasIndex: -1,

      //errores
      snack: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      //dicionarrio alertas
      dictionary: {
        custom: {
          indicadores_etnicos: {
            required: () => "El campo indicadores no puede estar en blanco",
          },
          tipopregunta: {
            required: () => "El campo Tipo de pregunta es requerido",
          },
          pregunta: {
            required: () => "El campo pregunta es requerido",
          },
          cantidad: {
            required: () => "El campo cantidad es requerido",
            numeric: "El campo solo recibe números enteros",
          },
          orden: {
            required: () => "El campo orden es requerido",
            numeric: "El campo solo recibe números enteros",
          },
          ordenpregunta: {
            required: () => "El campo orden es requerido",
            numeric: "El campo solo recibe números enteros",
          },
        },
      },
    };
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  methods: {
    ...mapActions([
      "get_cuestionario",
      "get_clasificaciones",
      "get_indicadorbycategoria",
      "get_tipopregunta",
      "post_cuestionario",
    ]),
    stateform(opcion) {
      if (opcion == "preguntas") {
        this.TabPeguntas = false;
        this.statetabs = 1;
        this.TabCuestionario = true;
      } else {
        this.TabPeguntas = true;
        this.statetabs = 0;
        this.TabCuestionario = false;
        this.framepreguntas = false;
      }
      this.framesubform = true;
    },
    grideditCuestionario(item, opcion) {
      this.editedCuestionarioIndex = this.DataCuestionario.indexOf(item);
      this.EditedCuestionario = Object.assign({}, item);
      this.DataPreguntas = this.EditedCuestionario.pregunta;

      this.stateform(opcion);
    },
    grideditPregunta(item) {
      this.editedPreguntasIndex = this.DataPreguntas.indexOf(item);
      this.EditedPreguntas = Object.assign({}, item);

      this.framepreguntas = true;
    },
    newcuestionario() {
      this.EditedCuestionario = {
        idcuestionario: 0,
        cantidad: 0,
        idindicador: "",
        codigoindicador: "",
        orden: 0,
        activo: false,
      };
      this.stateform("edit");
    },
    newPregunta() {
      this.EditedPreguntas = {
        idpregunta: 0,
        nombre: "",
        nombretipopregunta: "",
        idtipopregunta: "",
        orden: 0,
        activo: false,
        idcuestionario: this.EditedCuestionario.idcuestionario,
      };

      this.framepreguntas = true;
    },
    cerrarsubform() {
      this.framesubform = false;
      this.framepreguntas = false;
      this.EditedCuestionario = [];
      this.EditedPreguntas = [];
    },
    guardarcuestionario() {
      this.framesubform = false;

      let Indicadorsearch = this.EditedCuestionario.idindicador;
      let IdindicadorSelect = this.gindicadores.filter(function (params) {
        if (params.idindicador == Indicadorsearch) return params;
      });

      if (this.editedCuestionarioIndex == -1) {
        if (this.DataCuestionario == undefined) {
          this.DataCuestionario = [];
        }
        this.DataCuestionario.push({
          idcuestionario: 0,
          cantidad: this.EditedCuestionario.cantidad,
          idindicador: IdindicadorSelect[0].idindicador,
          codigoindicador: IdindicadorSelect[0].codigo,
          orden: this.EditedCuestionario.orden,
          activo: this.EditedCuestionario.activo,
        });
      } else {
        let TmpEditedCuestionario = {
          idcuestionario: this.EditedCuestionario.idcuestionario,
          cantidad: this.EditedCuestionario.cantidad,
          idindicador: IdindicadorSelect[0].idindicador,
          codigoindicador: IdindicadorSelect[0].codigo,
          orden: this.EditedCuestionario.orden,
          activo: this.EditedCuestionario.activo,
          actualizar: true,
        };
        Object.assign(
          this.DataCuestionario[this.editedCuestionarioIndex],
          TmpEditedCuestionario
        );
        this.editedCuestionarioIndex = -1;
      }
      this.post_cuestionario({ data: this.DataCuestionario });
      this.EditedCuestionario = [];
    },
    validarformCuestionario() {
      this.loading = true;
      this.$validator.validateAll("form-cuestionario").then((result) => {
        if (!result) {
          this.snack = true;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          this.loading = false;
          return;
        } else {
          //validamos que el indicador ya no exista
          let Indicadorsearch = this.EditedCuestionario.idindicador;
          let Validandoduplicado = this.gcuestionarios.filter(function (
            params
          ) {
            if (params.idindicador == Indicadorsearch) return params;
          });
          if (Validandoduplicado.length > 0 && this.editedCuestionarioIndex == -1) {
            this.snack = true;
            this.MesaggeInfo.mensajeRespuesta =
              "El indicador seleccionado ya tiene asignado un cuestionario ";
            this.MesaggeInfo.color = "infovue";
            this.loading = false;
            return;
          } else {
            this.guardarcuestionario();
          }
        }
      });
    },
    guardarpreguntas() {
      this.framepreguntas = false;
      let Tpsearch = this.EditedPreguntas.idtipopregunta;

      let TPSelect = this.gtipopreguntas.filter(function (params) {
        if (params.idtipopregunta == Tpsearch) return params;
      });
      if (this.editedPreguntasIndex == -1) {
        if (this.DataPreguntas == undefined) this.DataPreguntas = [];

        this.DataPreguntas.push({
          idpregunta: 0,
          nombre: this.EditedPreguntas.nombre,
          nombretipopregunta: TPSelect[0].nombre,
          idtipopregunta: TPSelect[0].idtipopregunta,
          activo: this.EditedPreguntas.activo,
          orden: this.EditedPreguntas.orden,
          idcuestionario: this.EditedCuestionario.idcuestionario,
        });
        this.EditedPreguntas = [];
      } else {
        this.EditedPreguntas.actualizar = true;
        Object.assign(
          this.DataPreguntas[this.editedPreguntasIndex],
          this.EditedPreguntas
        );
        this.editedPreguntasIndex = -1;
      }
      this.EditedCuestionario.pregunta = this.DataPreguntas;
      let CuestionarioList = [];
      CuestionarioList.push(this.EditedCuestionario);
      this.post_cuestionario({ data: CuestionarioList });
      this.EditedPreguntas = [];
    },
    validarformpreguntas() {
      this.loading = true;
      this.$validator.validateAll("form-preguntas").then((result) => {
        if (!result) {
          this.snack = true;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          this.guardarpreguntas();
        }
      });
    },
    deleteCuestionario(item) {
      this.loading = true;
      let editedIndex = this.DataCuestionario.indexOf(item);
      let Edited = Object.assign({}, item);
      Edited.eliminar = true;
      Object.assign(this.DataCuestionario[editedIndex], Edited);
      this.post_cuestionario({ data: this.DataCuestionario });
    },
    deletePreguntas(item) {
      this.loading = true;
      let editedIndex = this.DataPreguntas.indexOf(item);
      let Edited = Object.assign({}, item);
      Edited.eliminar = true;
      Object.assign(this.DataPreguntas[editedIndex], Edited);

      this.EditedCuestionario.pregunta = [];
      this.EditedCuestionario.pregunta = this.DataPreguntas;
      let Cuestionario = [];
      Cuestionario.push(this.EditedCuestionario);
      this.post_cuestionario({ data: Cuestionario });
    },
    showpregunta(item) {
      if (item.pregunta == undefined) return true;

      if (item.pregunta.length > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    this.get_cuestionario();
    this.get_clasificaciones();
    this.get_tipopregunta();
  },
  computed: {
    ...mapGetters([
      "gcuestionarios",
      "gclasificaciones",
      "gindicadores",
      "gtipopreguntas",
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
  },
  watch: {
    gcuestionarios: function () {
      this.DataCuestionario = this.gcuestionarios;
      if (this.editedCuestionarioIndex >= 0) {
        this.EditedCuestionario = this.DataCuestionario[
          this.editedCuestionarioIndex
        ];
        this.DataPreguntas = this.EditedCuestionario.pregunta;
      }
    },
    gclasificaciones: function () {
      let tematico = this.gclasificaciones.filter(function (params) {
        if (params.nombre == "Étnico") return params;
      });
      if (tematico.length > 0) {
        this.get_indicadorbycategoria({
          params: {
            idclasificador: tematico[0].idclasificacion,
          },
        });
      }
    },
    ginformation() {
      if (this.loading) {
        this.MesaggeInfo = this.ginformation;
        if (this.ginformation.idGenerado == 1) {
          this.get_cuestionario();
          this.MesaggeInfo.mensajeRespuesta = "Operacion realizada con exito";
        }

        this.snack = true;
        console.log(this.MesaggeInfo.mensajeRespuesta);
        //este console por favor dejarlo, es para que el usuario tenga en consola los posibles mensajes por si no alcanza a leerlo
        this.loading = false;
        store.dispatch("mensaje/set_reset");
      }
    },
  },
};
</script>